import { Card } from "antd";
import React from "react";
import { FilePickerDocumentListContainer } from "./file-picker-document-list.container";
import { SelectedFileInfo } from "./verification-packet-document-picker";
import { FilePickerCaseListContainer } from "./file-picker-case-list.container";

interface FilePickerProps {
  handleFileSelection: (fileInfo: SelectedFileInfo) => void;
}
export interface SelectedCase {
  id: string;
  caseType: string;
  isArchived?: boolean;
}

export const FilePicker: React.FC<FilePickerProps> = ({
  handleFileSelection
}) => {
  const [selectedCaseInfo, setSelectedCaseInfo] = React.useState<SelectedCase>(
    {} as SelectedCase
  );

  const setCaseInfo = (selectedCaseId: string, selectedCaseType: string, selectedIsArchived?: boolean) => {
    setSelectedCaseInfo({
      id: selectedCaseId,
      caseType: selectedCaseType,
      isArchived: selectedIsArchived
    });
  };
  
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100%",
      }}
    >
      <Card
        title="Cases"
        style={{
          minWidth: "300px",
          maxWidth: "300px",
          minHeight: "700px",
          borderRadius: "0px",
        }}
      >
        <FilePickerCaseListContainer setCaseInfo={setCaseInfo} />
      </Card>
      <Card
        title="Documents"
        style={{
          minWidth: "600px",
          maxWidth: "600px",
          minHeight: "100px",
          borderRadius: "0px",
        }}
      >
        <FilePickerDocumentListContainer selectedCaseInfo={selectedCaseInfo} handleFileSelection={handleFileSelection}/>
      </Card>
    </div>
  );
};
